import { RequestForAnalysisDetailsPage } from './RequestForAnalysisDetailsPage'
import RequestForAnalysisDetailsContextProvider from './RequestForAnalysisDetailsProvider'
export const RequestForAnalysisContainer = () => {
  return (
    <RequestForAnalysisDetailsContextProvider>
      <RequestForAnalysisDetailsPage />
    </RequestForAnalysisDetailsContextProvider>
  )
}
